<template>
  <div class="search-popup pa-2" ref="searchPopup" v-resize="onResize">
    <div class="subheading">{{ $t('COMMON.SEARCH_POPUP_DESC') }}</div>
    <v-icon size="18" @click="onClose(true)">fas fa-times</v-icon>
  </div>
</template>

<script>
export default {
  data() {
    return {
      close: false
    };
  },

  methods: {
    onResize() {
      console.log("onResize");
      if (this.close) return;
      this.setPopupPosition();
    },
    setPopupPosition() {
      console.log("Setpopupposition")
      setTimeout(() => {
        const searchFilterBtn = this.$vuetify.breakpoint.smAndDown
          ? document.querySelector(".xs-searchbar .filter-btn")
          : document.querySelector(".sm-searchbar .filter-btn");
        if (!searchFilterBtn) return;
        const top = searchFilterBtn.offsetTop;
        const left = searchFilterBtn.offsetLeft;
        const height = searchFilterBtn.offsetHeight;

        console.log({ top, left, height });

        this.$refs.searchPopup.style.top = `${top + height + 26}px`;
        this.$refs.searchPopup.style.left = `${left - 190}px`;
        this.$refs.searchPopup.style.display = "block";

        // Hide after 10s
        setTimeout(
          () => this.onClose(false),
          10000
        );
      }, 3000);
    },
    onClose(forever = false) {
      this.close = true;
      this.$refs.searchPopup.style.display = "none";
      if (forever) this.$app.searchPopupClosed();
    }
  }
};
</script>

<style lang="scss" scoped>
$borderWidth: 1px;
$trangleWidth: 14px;

.search-popup {
  display: none;
  position: absolute;
  width: 250px;
  background-color: #eaeaee;
  border: $borderWidth solid #4a4a4a;
  border-radius: 8px;
  animation: fadeIn 1s;

  &:after,
  &:before {
    bottom: 100%;
    right: 45px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #eaeaee;
    border-width: $trangleWidth;
    margin-right: -$trangleWidth;
  }

  &:before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #4a4a4a;
    border-width: $trangleWidth + 1 + $borderWidth;
    margin-right: -($trangleWidth + 1 + $borderWidth);
  }

  .v-icon {
    position: absolute;
    bottom: 6px;
    right: 8px;
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
